/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Fullscreen_FailedInputs */

const th_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดเต็มหน้าจอไม่ได้ ดูต่อที่นี่หรือลองอีกครั้ง`)
};

const en_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullscreen could not open. You can keep watching here or try again.`)
};

const ja_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全画面表示にできませんでした。このまま視聴するか、もう一度お試しください。`)
};

const zh_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法进入全屏。你可以在这里继续观看，或再试一次。`)
};

const es_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se ha podido abrir la pantalla completa. Puedes seguir viéndolo aquí o reintentarlo.`)
};

const pt_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tela cheia não pôde abrir. Você pode continuar assistindo aqui ou tentar de novo.`)
};

const id_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layar penuh tidak bisa dibuka. Anda bisa terus menonton di sini atau coba lagi.`)
};

const fr_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le plein écran n’a pas pu s’ouvrir. Vous pouvez continuer à regarder ici ou réessayer.`)
};

const tl_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi nabuksan ang buong screen. Maaari kang magpatuloy sa panonood dito o subukang muli.`)
};

const vi_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không mở được toàn màn hình. Bạn có thể tiếp tục xem ở đây hoặc thử lại.`)
};

const ko_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체 화면을 열지 못했습니다. 여기서 계속 보거나 다시 시도할 수 있습니다.`)
};

const de_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Vollbild ließ sich nicht öffnen. Du kannst hier weiterschauen oder es erneut versuchen.`)
};

const ru_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось открыть полноэкранный режим. Можно продолжить смотреть здесь или попробовать снова.`)
};

const tr_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tam ekran açılamadı. Burada izlemeye devam edebilir ya da yeniden deneyebilirsiniz.`)
};

const it_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile aprire lo schermo intero. Puoi continuare a guardare qui o riprovare.`)
};

const pl_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się otworzyć pełnego ekranu. Możesz oglądać dalej tutaj albo spróbować ponownie.`)
};

const uk_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вдалося відкрити повний екран. Можна дивитися далі тут або спробувати ще раз.`)
};

const hi_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्ण स्क्रीन नहीं खुल सकी। आप यहीं देखते रह सकते हैं या फिर कोशिश कर सकते हैं।`)
};

const ar_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذّر فتح ملء الشاشة. يمكنك المتابعة هنا أو إعادة المحاولة.`)
};

const ms_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrin penuh tidak dapat dibuka. Anda boleh terus menonton di sini atau cuba lagi.`)
};

const bn_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পূর্ণ পর্দা খোলা যায়নি। এখানেই দেখা চালিয়ে যেতে পারেন বা আবার চেষ্টা করতে পারেন।`)
};

const zh_tw2_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法進入全螢幕。你可以在這裡繼續觀看，或再試一次。`)
};

const zh_hk2_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法進入全熒幕。你可以在這裡繼續觀看，或再試一次。`)
};

const ur_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پوری اسکرین نہ کھل سکی۔ آپ یہیں دیکھتے رہ سکتے ہیں یا دوبارہ کوشش کر سکتے ہیں۔`)
};

const fa_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تمام‌صفحه باز نشد. می‌توانید همین‌جا تماشا کنید یا دوباره تلاش کنید.`)
};

const sw_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrini nzima haikufunguka. Unaweza kuendelea kutazama hapa au kujaribu tena.`)
};

const nl_video_fullscreen_failed = /** @type {(inputs: Video_Fullscreen_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volledig scherm kon niet worden geopend. Je kunt hier verder kijken of het opnieuw proberen.`)
};

/**
* | output |
* | --- |
* | "Fullscreen could not open. You can keep watching here or try again." |
*
* @param {Video_Fullscreen_FailedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_fullscreen_failed = /** @type {((inputs?: Video_Fullscreen_FailedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Fullscreen_FailedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_fullscreen_failed(inputs)
	if (locale === "ja") return ja_video_fullscreen_failed(inputs)
	if (locale === "zh") return zh_video_fullscreen_failed(inputs)
	if (locale === "es") return es_video_fullscreen_failed(inputs)
	if (locale === "pt") return pt_video_fullscreen_failed(inputs)
	if (locale === "id") return id_video_fullscreen_failed(inputs)
	if (locale === "fr") return fr_video_fullscreen_failed(inputs)
	if (locale === "tl") return tl_video_fullscreen_failed(inputs)
	if (locale === "vi") return vi_video_fullscreen_failed(inputs)
	if (locale === "ko") return ko_video_fullscreen_failed(inputs)
	if (locale === "de") return de_video_fullscreen_failed(inputs)
	if (locale === "ru") return ru_video_fullscreen_failed(inputs)
	if (locale === "tr") return tr_video_fullscreen_failed(inputs)
	if (locale === "it") return it_video_fullscreen_failed(inputs)
	if (locale === "pl") return pl_video_fullscreen_failed(inputs)
	if (locale === "uk") return uk_video_fullscreen_failed(inputs)
	if (locale === "hi") return hi_video_fullscreen_failed(inputs)
	if (locale === "ar") return ar_video_fullscreen_failed(inputs)
	if (locale === "ms") return ms_video_fullscreen_failed(inputs)
	if (locale === "bn") return bn_video_fullscreen_failed(inputs)
	if (locale === "zh-TW") return zh_tw2_video_fullscreen_failed(inputs)
	if (locale === "zh-HK") return zh_hk2_video_fullscreen_failed(inputs)
	if (locale === "ur") return ur_video_fullscreen_failed(inputs)
	if (locale === "fa") return fa_video_fullscreen_failed(inputs)
	if (locale === "sw") return sw_video_fullscreen_failed(inputs)
	if (locale === "nl") return nl_video_fullscreen_failed(inputs)
	return en_video_fullscreen_failed(inputs)
});